import { t } from '@lingui/core/macro';
import { BadgeInternal } from './Badge';

export const NewBadge = () => {
  return (
    <BadgeInternal style={{ backgroundColor: 'lightgreen', color: 'green' }}>
      {t`NEW`}
    </BadgeInternal>
  );
};
